import { render, staticRenderFns } from "./SimpleTextCard.vue?vue&type=template&id=214bc9aa&scoped=true"
import script from "./SimpleTextCard.vue?vue&type=script&lang=js"
export * from "./SimpleTextCard.vue?vue&type=script&lang=js"
import style0 from "./SimpleTextCard.vue?vue&type=style&index=0&id=214bc9aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214bc9aa",
  null
  
)

export default component.exports